/* eslint-disable*/
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { useRoutes, useLocation } from 'react-router-dom';
import { ThemeProvider, StyledEngineProvider } from '@material-ui/core/styles';
import GlobalStyles from 'components/GlobalStyles';
import theme from 'theme/index';
import routes from 'routes.js';
import { setError } from 'feactures/errorSlice';
import StickyButton from 'components/atoms/button/StickyButton';
import { currentchannel } from 'feactures/channel/channelSlice';

import 'moment/locale/ja';
import { userLoggedIn, userinfo } from 'feactures/user/userSlice';
import { groupListLength } from 'feactures/monitoring/groupSlice';
import NoticeDialog from 'components/atoms/notice/NodiceDialog';

// export const apiUrl = 'http://52.197.202.214:3000/api/'; //boxwb1
// export const apiUrl = 'http://18.183.158.221:3000/api/'; //web2
// export const apiUrl = 'https://www.oxcim.jp/api/'; //本番
export const apiUrl = 'api/'; //本番
// export const apiUrl = 'http://127.0.0.1:5000/api/'; //ローカル

const App = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(userLoggedIn);
  const channel = useSelector(currentchannel);
  const userInfo = useSelector(userinfo);
  const groupLength = useSelector(groupListLength);

  //ユーザーの各モールで有償プラン利用中のときのみ、premiumStatusをtrueにする←マーケットビューにて使用
  let premiumStatus = false;
  if (
    (channel == 1 && userInfo.plan.amazon.status == 1) ||
    (channel == 1 && userInfo.trial.Amazon.trial)
  ) {
    premiumStatus = true;
  } else if (
    (channel == 2 && userInfo.plan.rakuten.status == 1) ||
    (channel == 2 && userInfo.trial.楽天.trial)
  ) {
    premiumStatus = true;
  } else if (
    (channel == 3 && userInfo.plan.yahoo.status == 1) ||
    (channel == 3 && userInfo.trial.yahoo.trial)
  ) {
    premiumStatus = true;
  }

  const routing = useRoutes(routes(isLoggedIn, premiumStatus, groupLength));
  const location = useLocation();

  // 画面が遷移したらエラーメッセージを初期化
  useEffect(() => {
    dispatch(setError({ state: null, data: null }));
  }, [location.pathname]);

  const today = new Date();
  const targetDate = new Date(today.getFullYear(), 6, 27);

  const idList = [
    1, 10, 12, 13, 15, 16, 18, 19, 20, 21, 23, 24, 25, 27, 28, 29, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 43, 44, 45, 47, 51, 53, 54, 55, 56, 61, 62, 63, 65,
    66, 69, 70, 71, 74, 75, 77, 79, 80, 81, 82, 85, 87, 88, 89, 90, 91, 94, 95,
    96, 100, 101, 102, 104, 105, 106, 108, 109, 110, 111, 115, 118, 120, 121,
    122, 123, 124, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
    138, 139, 140, 141, 142, 143, 144, 145, 146, 148, 150, 151, 152, 153, 154,
    155, 156, 157, 158, 159, 160, 161, 162, 163, 165, 166, 167, 168, 169, 170,
    171, 172, 173, 174, 175, 176, 177, 178, 180, 181, 183, 184, 185, 186, 187,
    191, 192, 193, 194, 195, 196, 197, 199, 202, 205, 206, 207, 209, 211, 220,
    222, 223, 224, 227, 232, 233, 234, 235, 237, 238, 239, 240, 242, 245, 246,
    247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261,
    262, 263, 264, 266, 267, 268, 269, 270, 271, 272, 274, 275, 276, 278, 279,
    280, 281, 282, 284, 285, 287, 288, 289, 290, 291, 292, 294, 295, 296, 299,
    300, 304, 305, 306, 307, 309, 310, 311, 313, 315, 316, 317, 318, 319, 320,
    321, 322, 323, 324, 326, 327, 329, 331, 332, 333, 336, 337, 338, 345, 346,
    349, 350, 351, 352, 354, 355, 356, 358, 360, 363, 364, 365, 367, 369, 371,
    373, 374, 376, 377, 379, 381, 383, 384, 385, 387, 388, 389, 390, 391, 393,
    395, 396, 397, 398, 399, 400, 405, 406, 409, 411, 412, 413, 414, 415, 416,
    417, 418, 419, 422, 423, 424, 425, 430, 431, 432, 433, 435, 438, 440, 442,
    443, 444, 445, 446, 447, 448, 449, 450, 452, 454, 455, 457, 458, 459, 460,
    462, 463, 464, 465, 466, 467, 468, 469, 471, 474, 475, 476, 478, 479, 480,
    481, 482, 483, 484, 486, 487, 489, 490, 491, 492, 495, 496, 497, 498, 499,
    500, 501, 502, 503, 508, 509, 510, 511, 513, 514, 515, 516, 518, 519, 520,
    523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 535, 536, 537, 539,
    540, 542, 543, 545, 549, 550, 553, 554, 555, 556, 557, 558, 559, 560, 562,
    563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 574, 576, 577, 578,
    579, 580, 581, 582, 584, 585, 586, 587, 589, 592, 593, 594, 595, 596, 597,
    599, 601, 602, 603, 604, 605, 606, 607, 608, 609, 611, 612, 613, 614, 615,
    617, 618, 619, 620, 621, 622, 623, 626, 627, 628, 629, 630, 632, 633, 634,
    635, 636, 637, 638, 639, 640, 641, 642, 644, 645, 647, 648, 649, 650, 651,
    652, 653, 654, 655, 656, 657, 659, 660, 661, 663, 664, 665, 666, 667, 668,
    669, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684,
    685, 686, 687, 688, 689, 690, 691, 693, 694, 695, 696, 698, 699, 700, 701,
    702, 703, 704, 705, 706, 707, 708, 709, 711, 713, 714, 715, 717, 718, 719,
    720, 721, 723, 724, 725, 727, 728, 729, 730, 731, 732, 733, 734, 735, 737,
    738, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753,
    754, 756, 757, 758, 759, 760, 761, 762, 764, 765, 766, 767, 768, 771, 772,
    773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787,
    788, 789, 790, 791, 792, 793, 794, 795, 796, 798, 799, 800, 801, 802, 803,
    804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818,
    819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 833, 834,
    835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 849, 850,
    852, 853, 854, 855, 857, 858, 859, 860, 861, 862, 863, 864, 866, 868, 869,
    870, 871, 872, 873, 874, 875, 876, 877, 878, 882, 883, 885, 886, 887, 888,
    889, 890, 891, 892, 893, 894, 895, 896, 897, 898, 899, 900, 901, 902, 903,
    904, 905, 906, 907, 909, 910, 911, 912, 913, 915, 916, 918, 919, 920, 921,
    922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937,
    939, 940, 941, 942, 944, 945, 947, 948, 951, 952, 953, 954, 955, 956, 957,
    958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 972, 974, 975,
    976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990,
    991, 992, 993, 994, 995, 996, 997, 998, 1000, 1001, 1002, 1003, 1004, 1005,
    1006, 1007, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1020, 1021,
    1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033,
    1034, 1035, 1036, 1039, 1040, 1041, 1044, 1046, 1048, 1049, 1050, 1051,
    1052, 1053, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064,
    1065, 1066, 1067, 1072, 1074, 1075, 1077, 1079, 1080, 1082, 1083, 1084, 1086
  ];

  let a_id_flag;
  if (idList.includes(userInfo.accountId)) {
    a_id_flag = true;
  } else {
    a_id_flag = false;
  }

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        {routing}
        {(userInfo.trial.trial_notice ||
          userInfo.trial.advertise ||
          (a_id_flag &&
            userInfo.trial.楽天.end_date === '' &&
            today <= targetDate)) && <NoticeDialog />}
        {/* {isLoggedIn && <StickyButton />} */}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
